import { IconLink, Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import type { UTMICampaign as UTMType } from 'typings'
import { Tag, TagsList } from '../../../Tag'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDescription,
  RuleIcon,
} from '../../RuleStack'
import { RuleDefaultActions } from '../../RuleStack/DefaultActions'
import { messages } from './messages'

type Props = {
  values: UTMType | undefined
  onEdit: () => void
  onRemove: () => void
}

export function View(props: Props) {
  const { values, onEdit, onRemove } = props
  const { $t } = useIntl()

  if (!values) return

  return (
    <Rule onClick={onEdit}>
      <RuleIcon>
        <IconLink />
      </RuleIcon>

      <RuleDescription>
        <Text variant="body">
          {$t(messages.viewDescription, {
            b: (content: React.ReactNode) => (
              <Text variant="body">{content}</Text>
            ),
            count: values.utmiCampaign?.length,
          })}
        </Text>
      </RuleDescription>

      <RuleContent>
        <TagsList>
          {values.utmiCampaign.map((utm, index) => (
            <Tag key={index}>{utm}</Tag>
          ))}
        </TagsList>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
